export const URI_DEVICES = 'devices';
